import { prefixerI } from './common'

export const ROUTE_PPG_MOV_INV_COSTEADO = prefixerI('mov_inv_costeado')
export const ROUTE_PPG_CONSULTA_ORDEN_PEDIDO = prefixerI('consulta_orden_pedido')
export const ROUTE_PPG_BANDEJA_ENTRADA_PROFORMAS = prefixerI('bandeja_entrada_proformas')
